import {SelectInput, ReferenceInput, TextInput} from 'react-admin';
import React from "react";

const ComboUnidadNegocio = (props) => {
    const isReadonly = props.readOnly;
    const isvariant = props.variant;
    return (
        <ReferenceInput label="Unidad Negocio" source="id_unidad_negocio" reference="UnidadNegocio"
                        // variant="outlined"
                        variant={isvariant===undefined || isvariant===null ? 'outlined' : isvariant.trim()}
        >
            <SelectInput optionText="unidad_negocio_d" InputLabelProps={{shrink: true}}
                         inputProps={{readOnly: isReadonly}} />
        </ReferenceInput>
    )
};

export default ComboUnidadNegocio;
